import {
  createUnifiedTheme,
  palettes,
  genPageTheme,
  shapes,
} from '@backstage/theme';

export const expertTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: '#1B2A4A' },
    secondary: { main: '#000000' },
    background: {
      default: '#CCCCCC',
      paper: '#BBBBBB',
    },
    navigation: {
      background: '#1B2A4A',
      color: '#CCCCCC',
      indicator: '#6FA8DC',
      selectedColor: '#FFFFFF',
      navItem: {
        hoverBackground: '#2C3E5A',
      },
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#CCCCCC !important',
        },
        '#root': {
          backgroundColor: '#CCCCCC',
        },
        '@keyframes pulse': {
          '0%, 100%': { opacity: 1 },
          '50%': { opacity: 0.4 },
        },
        '.qa-template-row:focus-visible': {
          boxShadow: '0 0 0 2px #1976d2 inset',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    BackstageContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#CCCCCC',
        },
      },
    },
    BackstagePage: {
      styleOverrides: {
        root: {
          backgroundColor: '#CCCCCC',
        },
      },
    },
    BackstageHeader: {
      styleOverrides: {
        header: {
          backgroundColor: '#1B2A4A',
          color: '#FFFFFF',
        },
      },
    },
    BackstageItemCardHeader: {
      styleOverrides: {
        root: {
          backgroundColor: '#1B2A4A',
          color: '#FFFFFF',
        },
      },
    },
    BackstageHeaderTabs: {
      styleOverrides: {
        tabsWrapper: {
          backgroundColor: '#1B2A4A',
        },
      },
    },
    BackstageTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    CatalogReactUserListPicker: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.MuiGrid-container': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          backgroundColor: '#BBBBBB',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1B2A4A',
        },
      },
    },
  },
  pageTheme: {
    home: genPageTheme({ colors: ['#1B2A4A', '#2C3E5A'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#1B2A4A', '#3A506B'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({
      colors: ['#1B2A4A', '#4A6274'],
      shape: shapes.round,
    }),
    service: genPageTheme({
      colors: ['#1B2A4A', '#2C3E5A'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#1B2A4A', '#3A506B'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#1B2A4A', '#4A6274'],
      shape: shapes.round,
    }),
    other: genPageTheme({
      colors: ['#1B2A4A', '#2C3E5A'],
      shape: shapes.wave,
    }),
    app: genPageTheme({ colors: ['#1B2A4A', '#2C3E5A'], shape: shapes.wave }),
  },
  defaultPageTheme: 'home',
});
